export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-1440w.137554f4.webp";